import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExpensesClassificationTypeValueObject  {
    _originalTypeClassName = "zERP.BO.ExpensesClassificationTypeValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExpensesClassificationTypeValueObject.translate = translateService;
}
this.Category = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.CodeStr = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
CodeStr:any;
FullName:any;
Category:any;
static setCategory = ($this, items) => {
                if (items == null) items = [];
                if ($this.Category == null) $this.Category = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Category.length > 0) {
                    Domain.ExpensesClassificationTypeValueObject.removeCategory($this, $this.Category[0]);
                }

                Domain.ExpensesClassificationTypeValueObject.addManyCategory($this, copyItems);
            }
static addManyCategory = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExpensesClassificationTypeValueObject.addCategory($this, items[i]);
                }
            }
static addCategory = ($this, item) => {
                if ($this.Category == null) $this.Category = [];
                if (item == null || $this.Category.indexOf(item) > -1) return;
                $this.Category.push(item);
Domain.ExpensesClassificationCategoryValueObject.addTypes(item, $this);
}
static addRangeCategory = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExpensesClassificationTypeValueObject.addCategory($this, item));
            }
static removeCategory = ($this, item) => {
                if ($this == null || $this.Category == null || $this.Category.indexOf(item) === -1) return;
                var _index = $this.Category.indexOf(item);
                $this.Category.splice(_index, 1);
Domain.ExpensesClassificationCategoryValueObject.removeTypes(item, $this);
}
static clearCategory = ($this) => { $this.Category = null; }

static CodeToDescription($this: any): any{switch ($this?.Code) {case Domain.ExpensesClassificationTypeClassificationType.E3_101:
{
return "Εμπορεύματα έναρξης";}
case Domain.ExpensesClassificationTypeClassificationType.E3_102_001:
{
return "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Χονδρικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_102_002:
{
return "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Λιανικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_102_003:
{
return "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Αγαθών του άρθρου 39α παρ.5 του Κώδικα Φ.Π.Α. (ν.2859/2000)";}
case Domain.ExpensesClassificationTypeClassificationType.E3_102_004:
{
return "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_102_005:
{
return "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_102_006:
{
return "Αγορές εμπορευμάτων χρήσης (καθαρό ποσό)Λοιπά";}
case Domain.ExpensesClassificationTypeClassificationType.E3_104:
{
return "Εμπορεύματα λήξης";}
case Domain.ExpensesClassificationTypeClassificationType.E3_201:
{
return "Πρώτες ύλες και υλικά έναρξης/Παραγωγή";}
case Domain.ExpensesClassificationTypeClassificationType.E3_202_001:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Χονδρικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_202_002:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λιανικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_202_003:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_202_004:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_202_005:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λοιπά";}
case Domain.ExpensesClassificationTypeClassificationType.E3_204:
{
return "Αποθέματα λήξης πρώτων υλών και υλικών/Παραγωγή";}
case Domain.ExpensesClassificationTypeClassificationType.E3_207:
{
return "Προϊόντα και παραγωγή σε εξέλιξη έναρξης/Παραγωγή";}
case Domain.ExpensesClassificationTypeClassificationType.E3_209:
{
return "Προϊόντα και παραγωγή σε εξέλιξη λήξης/Παραγωγή";}
case Domain.ExpensesClassificationTypeClassificationType.E3_301:
{
return "Πρώτες ύλες και υλικά έναρξης/Αγροτική";}
case Domain.ExpensesClassificationTypeClassificationType.E3_302_001:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Χονδρικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_302_002:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λιανικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_302_003:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_302_004:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_302_005:
{
return "Αγορές πρώτων υλών και υλικών χρήσης (καθαρό ποσό)/Λοιπά";}
case Domain.ExpensesClassificationTypeClassificationType.E3_304:
{
return "Αποθέματα λήξης πρώτων υλών και υλικών/Αγροτική";}
case Domain.ExpensesClassificationTypeClassificationType.E3_307:
{
return "Προϊόντα και παραγωγή σε εξέλιξη έναρξης/Αγροτική";}
case Domain.ExpensesClassificationTypeClassificationType.E3_309:
{
return "Προϊόντα και παραγωγή σε εξέλιξη λήξης/Αγροτική";}
case Domain.ExpensesClassificationTypeClassificationType.E3_312:
{
return "Αποθέματα έναρξης (ζώων - φυτών)";}
case Domain.ExpensesClassificationTypeClassificationType.E3_313_001:
{
return "Αγορές ζώων - φυτών (καθαρό ποσό)/Χονδρικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_313_002:
{
return "Αγορές ζώων - φυτών (καθαρό ποσό)/Λιανικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_313_003:
{
return "Αγορές ζώων - φυτών (καθαρό ποσό)/Εξωτερικού Ενδοκοινοτικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_313_004:
{
return "Αγορές ζώων - φυτών (καθαρό ποσό)/Εξωτερικού Τρίτες Χώρες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_313_005:
{
return "Αγορές ζώων - φυτών (καθαρό ποσό)/Λοιπά";}
case Domain.ExpensesClassificationTypeClassificationType.E3_315:
{
return "Αποθέματα τέλους (ζώων - φυτών)/Αγροτική";}
case Domain.ExpensesClassificationTypeClassificationType.E3_581_001:
{
return "Παροχές σε εργαζόμενους/Μικτές αποδοχές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_581_002:
{
return "Παροχές σε εργαζόμενους/Εργοδοτικές εισφορές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_581_003:
{
return "Παροχές σε εργαζόμενους/Λοιπές παροχές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_582:
{
return "Ζημιές επιμέτρησης περιουσιακών στοιχείων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_583:
{
return "Χρεωστικές συναλλαγματικές διαφορές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_584:
{
return "Ζημιές από διάθεση-απόσυρση μη κυκλοφορούντων περιουσιακών στοιχείων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_001:
{
return "Προμήθειες διαχείρισης ημεδαπής - αλλοδαπής (management fees)";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_002:
{
return "Δαπάνες από συνδεδεμένες επιχειρήσεις";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_003:
{
return "Δαπάνες από μη συνεργαζόμενα κράτη ή από κράτη με προνομιακό φορολογικό καθεστώς";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_004:
{
return "Δαπάνες για ενημερωτικές ημερίδες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_005:
{
return "Έξοδα υποδοχής και φιλοξενίας";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_006:
{
return "Έξοδα ταξιδιών";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_007:
{
return "Ασφαλιστικές Εισφορές Αυτοαπασχολούμενων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_008:
{
return "Έξοδα και προμήθειες παραγγελιοδόχου για λογαριασμό αγροτών";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_009:
{
return "Λοιπές Αμοιβές για υπηρεσίες ημεδαπής";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_010:
{
return "Λοιπές Αμοιβές για υπηρεσίες αλλοδαπής";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_011:
{
return "Ενέργεια";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_012:
{
return "Ύδρευση";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_013:
{
return "Τηλεπικοινωνίες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_014:
{
return "Ενοίκια";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_015:
{
return "Διαφήμιση και προβολή";}
case Domain.ExpensesClassificationTypeClassificationType.E3_585_016:
{
return "Λοιπά έξοδα";}
case Domain.ExpensesClassificationTypeClassificationType.E3_586:
{
return "Χρεωστικοί τόκοι και συναφή έξοδα";}
case Domain.ExpensesClassificationTypeClassificationType.E3_587:
{
return "Αποσβέσεις";}
case Domain.ExpensesClassificationTypeClassificationType.E3_588:
{
return "Ασυνήθη έξοδα, ζημιές και πρόστιμα";}
case Domain.ExpensesClassificationTypeClassificationType.E3_589:
{
return "Προβλέψεις (εκτός από προβλέψεις για το προσωπικό)";}
case Domain.ExpensesClassificationTypeClassificationType.E3_882_001:
{
return "Αγορές ενσώματων παγίων χρήσης/Χονδρικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_882_002:
{
return "Αγορές ενσώματων παγίων χρήσης/Λιανικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_882_003:
{
return "Αγορές ενσώματων παγίων χρήσης/Εξωτερικού Ενδοκοινοτικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_882_004:
{
return "Αγορές ενσώματων παγίων χρήσης/Εξωτερικού Τρίτες Χώρες";}
case Domain.ExpensesClassificationTypeClassificationType.E3_883_001:
{
return "Αγορές μη ενσώματων παγίων χρήσης/Χονδρικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_883_002:
{
return "Αγορές μη ενσώματων παγίων χρήσης/Λιανικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_883_003:
{
return "Αγορές μη ενσώματων παγίων χρήσης/Εξωτερικού Ενδοκοινοτικές";}
case Domain.ExpensesClassificationTypeClassificationType.E3_883_004:
{
return "Αγορές μη ενσώματων παγίων χρήσης/Εξωτερικού Τρίτες Χώρες";}
case Domain.ExpensesClassificationTypeClassificationType.VAT_361:
{
return "Αγορές & δαπάνες στο εσωτερικό της χώρας";}
case Domain.ExpensesClassificationTypeClassificationType.VAT_362:
{
return "Αγορές & εισαγωγές επενδ. Αγαθών (πάγια)";}
case Domain.ExpensesClassificationTypeClassificationType.VAT_363:
{
return "Λοιπές εισαγωγές εκτός επενδ. Αγαθών (πάγια)";}
case Domain.ExpensesClassificationTypeClassificationType.VAT_364:
{
return "Ενδοκοινοτικές αποκτήσεις αγαθών";}
case Domain.ExpensesClassificationTypeClassificationType.VAT_365:
{
return "Ενδοκοινοτικές λήψεις υπηρεσιών άρθρ. 14.2.α";}
case Domain.ExpensesClassificationTypeClassificationType.VAT_366:
{
return "Λοιπές πράξεις λήπτη";}
case Domain.ExpensesClassificationTypeClassificationType.E3_103:
{
return "Απομείωση εμπορευμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_203:
{
return "Απομείωση πρώτων υλών και υλικών";}
case Domain.ExpensesClassificationTypeClassificationType.E3_303:
{
return "Απομείωση πρώτων υλών και υλικών";}
case Domain.ExpensesClassificationTypeClassificationType.E3_208:
{
return "Απομείωση προϊόντων και παραγωγής σε εξέλιξη";}
case Domain.ExpensesClassificationTypeClassificationType.E3_308:
{
return "Απομείωση προϊόντων και παραγωγής σε εξέλιξη";}
case Domain.ExpensesClassificationTypeClassificationType.E3_314:
{
return "Απομείωση ζώων - φυτών – εμπορευμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_106:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_205:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_305:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_210:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_310:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_318:
{
return "Ιδιοπαραγωγή παγίων - Αυτοπαραδόσεις - Καταστροφές αποθεμάτων";}
case Domain.ExpensesClassificationTypeClassificationType.E3_598_002:
{
return "Αγορές αγαθών που υπάγονται σε ΕΦΚ";}
default:
{
return "";}
}
}
static GetCodeStr($this: any): any{return $this?.Code + "";
}
static GetEnums(): any{let expensesClassificationTypeClassificationTypes = [];
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_101);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_102_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_102_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_102_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_102_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_102_005);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_102_006);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_104);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_201);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_202_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_202_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_202_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_202_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_202_005);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_204);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_207);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_209);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_301);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_302_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_302_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_302_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_302_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_302_005);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_304);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_307);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_309);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_312);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_313_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_313_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_313_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_313_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_313_005);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_315);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_581_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_581_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_581_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_582);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_583);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_584);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_005);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_006);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_007);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_008);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_009);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_010);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_011);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_012);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_013);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_014);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_015);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_585_016);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_586);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_587);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_588);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_589);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_882_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_882_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_882_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_882_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_883_001);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_883_002);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_883_003);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.E3_883_004);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.VAT_361);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.VAT_362);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.VAT_363);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.VAT_364);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.VAT_365);
expensesClassificationTypeClassificationTypes?.add(Domain.ExpensesClassificationTypeClassificationType.VAT_366);
return expensesClassificationTypeClassificationTypes;
}
static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}